import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./style.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import bg1 from "Assets/About/bg1.png";
import bg2 from "Assets/About/bg2.png";
import bg3 from "Assets/About/bg3.png";
import bg4 from "Assets/About/bg4.png";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>
                        <span>Why</span> Serene
                    </h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3 style={{ textAlign: "center" }}>Experienced</h3>
                        <p style={{ textAlign: "center" }}>
                            We are a team of experienced professionals who serve
                            the U.S. community by helping with U.S. tax laws.
                            Our team has been built for the process through
                            experienced knowledge and the caliber of hard work.
                            Our firm’s reputation is reflected in our high
                            standards, services, and specialized staff make sure
                            that every client is served by the expertise of our
                            whole firm and each individual’s strengths. <br />
                            <br />
                            <br />
                            As a dynamic CPA firm, we strive to adapt to our
                            client’s situations, while we help develop the right
                            plan for the success of each client’s needs.
                            <br /> We welcome you to contact us anytime.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>AFFORDABLE</h3>
                        <p>
                            We offer high-quality tax services and ensure our
                            clients receive accurate, efficient, and
                            stateof-the-art solutions at competitive prices,
                            with most returns priced reasonably. We are
                            committed to delivering exceptional service while
                            keeping it affordable and accessible to our clients.
                            <br />
                            <br />
                            <br />
                            and small business and financial consulting. Our
                            team makes it a point to be available 24/7 and be
                            able to provide insightful advice to enable clients
                            to make informed financial decision.
                        </p>
                    </div>
                </div>
                {/*   <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>Experienced</h3>
                        <p>
                            We offer with a quality tax services and ensures
                            clients accurate, efficient, state-of-the-art
                            service ot a competitive price with most returns
                            priced at o reasonable priceWe believe in quality
                            and remarkable service ond keep them affordably
                            available to our clients.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div> */}
                <div className={AboutClasses["section"]}>
                    <img src={bg1} alt="BG" />
                    <img src={bg2} alt="BG" />
                    <img src={bg3} alt="BG" />
                    <img src={bg4} alt="BG" />
                    <h3>CLIENT DATA INTEGRITY</h3>
                    <p>
                        Data integrity is a fundamental component of Serene Tax.
                        It is mandatory to keep your data and information safe
                        and secure. Clients' information is not used for any
                        inappropriate use. You can rely on us for 100% data
                        integrity.
                    </p>
                </div>
            </div>
        </Layout>
    );
}

export default About;
